<template>
  <div class="product-query common-page">
    <a-breadcrumb>
      <a-breadcrumb-item>产品管理</a-breadcrumb-item>
      <a-breadcrumb-item>查询产品</a-breadcrumb-item>
    </a-breadcrumb>

    <section class="search-box">
      <a-select
        v-model="productName"
        showSearch
        :showArrow="false"
        allowClear
        size="large"
        placeholder="产品名称"
        @change="searchSelectChange"
        style="width: 400px"
      >
        <a-select-option
          v-for="product in products_select"
          :key="product.id"
          :value="product.name"
          optionFilterProp="label"
        >{{product.name}}</a-select-option>
      </a-select>
      <a-button type="primary" size="large" @click="searchSelectChange(productName)">搜索</a-button>
    </section>

    <section class="search-result-number">
      <span>{{products.length}}个查询结果</span>
    </section>

    <section>
      <div class="common-box" v-for="(product, index) in products" :key="product.id">
        <div class="common-box-body">
          <div class="common-box-body-title">
            <span>{{product.name}}</span>
            <div>
              <a-button type="link" @click="goProductModify(product.id)" v-action="['admin']">修改</a-button>
            </div>
          </div>

          <!-- key:value格式 -->
          <a-row>
            <!-- <a-col :span="8" class="key-value-col">
              <span>产品ID：</span>
              <span>{{product.id}}</span>
            </a-col>-->
            <a-col :span="8" class="key-value-col">
              <span>授权算法编号：</span>
              <span>{{product.algorithmtype}}</span>
            </a-col>
            <a-col :span="8" class="key-value-col">
              <span>产品类型编号：</span>
              <span>{{product.type}}</span>
            </a-col>
            <a-col :span="8" class="key-value-col">
              <span>描述：</span>
              <span>{{product.description}}</span>
            </a-col>
          </a-row>

          <!-- 查看更多信息btn -->
          <a-button type="link" class="look-more-btn" @click="lookMore(index)">
            查看更多信息
            <a-icon type="down" />
          </a-button>

          <div class="more-wrapper" style="display:none;">
            <a-divider />

            <!-- 产品功能table -->
            <span class="table-name">产品功能</span>
            <a-table
              :columns="columns_func"
              :rowKey="(record, index) => index"
              :dataSource="product.functions"
              :pagination="false"
            ></a-table>

            <!-- 扩展属性table -->
            <span class="table-name">扩展属性</span>
            <a-table
              :columns="columns_attr"
              :rowKey="(record, index) => index"
              :dataSource="product.extendedAttributes"
              :pagination="false"
            />

            <!-- 收起btn -->
            <a-button type="link" class="pack-up-btn" @click="packUp(index)">
              收起
              <a-icon type="up" />
            </a-button>
          </div>
        </div>
      </div>
    </section>

    <spin v-if="loading"></spin>
  </div>
</template>

<script>
import axios from 'axios'
import { queryProduct, queryFunctions } from '../api/api'

const columns_func = [
  {
    title: '功能名称',
    dataIndex: 'name',
    width: '25%'
  },
  {
    title: '描述',
    dataIndex: 'description',
    width: '25%'
  },
  {
    title: '英文描述',
    dataIndex: 'descriptionEn',
    width: '25%'
  },
  {
    title: '功能code',
    dataIndex: 'code',
    width: '25%'
  }
]

const columns_attr = [
  {
    title: '属性名',
    dataIndex: 'key',
    width: '33%'
  },
  {
    title: '属性英文名',
    dataIndex: 'keyEn',
    width: '33%'
  },
  {
    title: '属性值',
    dataIndex: 'value',
    width: '33%'
  }
]

export default {
  name: 'product-query',

  data() {
    return {
      columns_func,
      columns_attr,
      products: [],
      products_select: [],
      functions: [],
      loading: false,
      productName: undefined
    }
  },

  created() {
    this.fetchData()
  },

  methods: {
    lookMore(index) {
      document.querySelectorAll('.more-wrapper')[index].style.display = 'block'
      document.querySelectorAll('.look-more-btn')[index].style.display = 'none'

      let functionsID = [...this.products[index].functionsID]
      let functions = []

      for (let i = 0; i < functionsID.length; i++) {
        for (let j = 0; j < this.functions.length; j++) {
          if (functionsID[i] === this.functions[j].id) {
            functions.push(this.functions[j])
          }
        }
      }
      this.$set(this.products[index], 'functions', functions)
    },

    packUp(index) {
      document.querySelectorAll('.more-wrapper')[index].style.display = 'none'
      document.querySelectorAll('.look-more-btn')[index].style.display = 'block'
    },

    goProductModify(id) {
      this.$router.push({
        name: 'product-modify',
        query: {
          productID: id
        }
      })
    },

    fetchData() {
      this.loading = true
      axios
        .all([queryProduct(), queryFunctions()])
        .then(
          axios.spread((res1, res2) => {
            if (res1.error.code === 0) {
              this.products = res1.response ? res1.response.products : []
              this.products_select = res1.response ? res1.response.products : []
            }
            if (res2.error.code === 0) {
              this.functions = res2.response ? res2.response.functions : []
            }
            this.loading = false
          })
        )
        .catch(err => {
          this.loading = false
        })
    },

    // 搜索下拉框change事件
    searchSelectChange(productName) {
      if (productName === undefined) {
        this.products = this.products_select
      } else {
        this.products = this.products_select.filter(product => product.name === productName)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.product-query {
}
</style>